var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Watch, Prop } from 'vue-property-decorator';
import { RoleService } from '~/services/management-service/role.service';
import { UserService } from '~/services/management-service/user.service';
import { FlowTaskService } from '~/services/domain-service/flow-task.service';
var option;
(function (option) {
    // 操作选项
    option[option["UP"] = 0] = "UP";
    option[option["DOWN"] = 1] = "DOWN";
})(option || (option = {}));
var numbreChars = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
var ProcessConfigCommon1 = /** @class */ (function (_super) {
    __extends(ProcessConfigCommon1, _super);
    function ProcessConfigCommon1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allRoleList = [];
        _this.saveModel = {
            flowNodeModels: [],
            taskName: '',
            commonState: 'ENABLED',
            applyCategory: '',
        };
        _this.rules = {
            taskName: [{ required: true, message: '请输入审批流程名称' }],
            commonState: [{ required: true, message: '请选择状态' }],
            applyCategory: [{ required: true, message: '请选择审批类型' }],
        };
        _this.taskNodeList = [];
        _this.submitLoading = false;
        return _this;
    }
    ProcessConfigCommon1.prototype.close = function () {
        this.reset();
    };
    ProcessConfigCommon1.prototype.success = function () {
        this.close();
    };
    ProcessConfigCommon1.prototype.onIdChange = function (val) {
        if (!val.id)
            return;
        if (val)
            this.revertData(val);
    };
    ProcessConfigCommon1.prototype.created = function () {
        this.getAllRoleList();
    };
    // 角色变化取审批人列表
    ProcessConfigCommon1.prototype.roleChange = function (row) {
        row.userIds = [];
        this.userService
            .getAllUsersList({ roleId: row.roleId, userStatus: 'ENABLED' })
            .subscribe(function (data) {
            row.userList = data;
        });
    };
    // 数据反显
    ProcessConfigCommon1.prototype.revertData = function (val) {
        var _this = this;
        this.flowTaskService.getFlowTask({ id: val.id }).subscribe(function (data) {
            if (data.flowNodes) {
                _this.saveModel.taskName = data.taskName;
                _this.saveModel.commonState = data.commonState;
                _this.saveModel.applyCategory = data.applyCategory;
                _this.saveModel.id = data.id;
                var a = data.flowNodes.map(function (v, index) {
                    return {
                        step: v.step - 1,
                        userIds: v.userIds,
                        roleId: v.roleId,
                        userList: v.userIds.map(function (e, eIndex) {
                            return {
                                id: e,
                                realName: v.realNames[eIndex]
                            };
                        })
                    };
                });
                _this.taskNodeList = a;
                _this.sort(_this.taskNodeList);
            }
        });
    };
    /**
     * 获取当前步数
     */
    ProcessConfigCommon1.prototype.stepChar = function (step) {
        var index = Number(step).valueOf();
        return numbreChars[index];
    };
    /**
     * 获取所有角色
     */
    ProcessConfigCommon1.prototype.getAllRoleList = function () {
        var _this = this;
        this.roleService.getAllRolesList().subscribe(function (data) {
            _this.allRoleList = data;
        });
    };
    // 节点移动
    ProcessConfigCommon1.prototype.move = function (type, index) {
        if (type === option.UP) {
            this.taskNodeList[index].step = this.taskNodeList[index].step - 1;
            this.taskNodeList[index - 1].step = this.taskNodeList[index - 1].step + 1;
        }
        else {
            this.taskNodeList[index].step = this.taskNodeList[index].step + 1;
            this.taskNodeList[index + 1].step = this.taskNodeList[index + 1].step - 1;
        }
        this.sort(this.taskNodeList);
    };
    //sort on operate in up or down
    ProcessConfigCommon1.prototype.sort = function (flowNodeModels) {
        this.taskNodeList = flowNodeModels.sort(function (a, b) { return a.step - b.step; });
    };
    /**
     * 删除节点
     */
    ProcessConfigCommon1.prototype.deleteNode = function (index) {
        this.taskNodeList.splice(index, 1);
        this.taskNodeList.forEach(function (v, index) {
            v.step = index;
        });
    };
    // 增加节点
    ProcessConfigCommon1.prototype.addTaskNode = function () {
        var newIndex = this.taskNodeList.length;
        if (newIndex > 4) {
            this.$message('最多增加五级审批');
            return;
        }
        this.taskNodeList.push({
            step: newIndex,
            userIds: [],
            userList: [],
        });
    };
    Object.defineProperty(ProcessConfigCommon1.prototype, "flowNodeNameList", {
        get: function () {
            var _this = this;
            return this.taskNodeList.map(function (v) {
                var role = _this.allRoleList.find(function (x) { return x.id === v.roleId; });
                var name = role ? role.roleName : '请配置';
                return {
                    step: v.step,
                    name: name,
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 提交表单
     */
    ProcessConfigCommon1.prototype.confirm = function () {
        var _this = this;
        // form表单检测
        var dataForm = this.$refs['form'];
        dataForm.validate(function (val) {
            if (!val)
                return;
            // 任务节中含有空数据或者表单验证不通过
            if (_this.checkError()) {
                return;
            }
            _this.submitLoading = true;
            var taskList = [];
            _this.taskNodeList.forEach(function (v, index) {
                taskList[index] = {
                    step: v.step + 1,
                    userIds: v.userIds,
                    roleId: v.roleId,
                };
            });
            _this.saveModel.flowNodeModels = taskList;
            // 如果saveModel存在id则为修改，不存则为新增
            if (!_this.saveModel.id) {
                _this.flowTaskService.addFlowTask(_this.saveModel).subscribe(function (data) {
                    _this.$message.success('新增成功');
                    _this.submitLoading = false;
                    _this.success();
                }, function () {
                    _this.submitLoading = false;
                });
            }
            else {
                _this.flowTaskService.updateFlowTask(_this.saveModel).subscribe(function (data) {
                    _this.$message.success('修改成功');
                    _this.submitLoading = false;
                    _this.success();
                }, function () {
                    _this.submitLoading = false;
                });
            }
        });
    };
    // 检测错误
    ProcessConfigCommon1.prototype.checkError = function () {
        var hasError = false;
        if (this.taskNodeList.length < 1) {
            this.$message('审批流程最少1步');
            return true;
        }
        for (var i = 0; i < this.taskNodeList.length; i++) {
            if (this.taskNodeList[i].userIds.length < 1) {
                this.$message("\u8BF7\u9009\u62E9\u7B2C" + (i + 1) + "\u6B65\u7684\u5BA1\u6279\u4EBA");
                hasError = true;
                break;
            }
        }
        return hasError;
    };
    ProcessConfigCommon1.prototype.reset = function () {
        this.taskNodeList = [];
        this.submitLoading = false;
        var form = this.$refs['form'];
        form.resetFields();
        this.saveModel = {
            flowNodeModels: [],
            taskName: '',
            commonState: 'ENABLED',
            applyCategory: '',
            id: '',
        };
    };
    __decorate([
        Dependencies(UserService)
    ], ProcessConfigCommon1.prototype, "userService", void 0);
    __decorate([
        Dependencies(RoleService)
    ], ProcessConfigCommon1.prototype, "roleService", void 0);
    __decorate([
        Dependencies(FlowTaskService)
    ], ProcessConfigCommon1.prototype, "flowTaskService", void 0);
    __decorate([
        Prop()
    ], ProcessConfigCommon1.prototype, "modifyData", void 0);
    __decorate([
        Emit('close')
    ], ProcessConfigCommon1.prototype, "close", null);
    __decorate([
        Watch('modifyData', { immediate: true })
    ], ProcessConfigCommon1.prototype, "onIdChange", null);
    ProcessConfigCommon1 = __decorate([
        Component({
            components: {},
        })
    ], ProcessConfigCommon1);
    return ProcessConfigCommon1;
}(Vue));
export default ProcessConfigCommon1;
